import { useEffect, useState } from "react";
import labels from "../../../utils/labels";
import SearchBar from "../../search/SearchBar";
import StandardButton from "../../UI/buttons/StandardButton";
import LabeledSection from "../../UI/LabeledSection";
import EmployeePreferencesList from "./EmployeePrefrencesList";
import api, { API_PATHS } from "../../../service/api";
import {
  EmployeePreferencesByCitizen,
  EmployeePreferencesParams,
} from "../../../types/employeeSettings";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNotification } from "../../../store/toastNotifications";

const EmployeePreferencesTab = () => {
  const [input, setInput] = useState("");
  const [employeePreferencesData, setEmployeePreferencesData] = useState<
    EmployeePreferencesByCitizen[]
  >([]);
  const dispatch = useAppDispatch();
  const employeeRef = useAppSelector(
    (state) => state.drawerSlice.selectedEmployee?.employeeRef,
  );
  const idScenario = useAppSelector(
    (state) => state.ganttChartSlice.ganttChartData?.idScenario,
  );

  useEffect(() => {
    if (!employeeRef || !idScenario) return;

    const fetchEmployeePreferences = async () => {
      try {
        const params: EmployeePreferencesParams = {
          employeeRef,
          idScenario,
        };
        const response = await api.get<EmployeePreferencesByCitizen[]>(
          API_PATHS.getEmployeePreferencesByCitizen,
          { params },
        );
        setEmployeePreferencesData(response.data);
      } catch (error: any) {
        dispatch(setNotification({ message: error.message }));
      }
    };
    fetchEmployeePreferences();
  }, [employeeRef, idScenario, dispatch]);

  return (
    <LabeledSection title={labels.preferences}>
      <SearchBar
        input={input}
        onInputChange={setInput}
        onClearAll={() => {}}
        placeholder={labels.searchForCitizen}
      />
      {/* todo: add dropdown */}

      <div className="flex gap-[var(--spacing-sm)] w-full justify-end">
        <StandardButton
          ariaLabel={labels.cancel}
          variant="SECONDARY"
          classes="w-fit"
          onClick={() => {}}
        >
          {labels.cancel}
        </StandardButton>
        <StandardButton
          ariaLabel={labels.addCitizen}
          variant="PRIMARY"
          classes="w-fit"
          onClick={() => {}}
        >
          {labels.addCitizen}
        </StandardButton>
      </div>

      <div className="flex w-full justify-end">
        <StandardButton
          variant="TERTIARY"
          onClick={() => {}}
          ariaLabel={labels.addPreference}
        >
          {labels.addPreference}
        </StandardButton>
      </div>

      {/* {employeePreferencesMock && <EmployeePreferencesList citizens={employeePreferencesMock} />} */}
      {employeePreferencesData && (
        <EmployeePreferencesList citizens={employeePreferencesData} />
      )}
    </LabeledSection>
  );
};

export default EmployeePreferencesTab;
